import {styled, Typography} from "@mui/material";

export const AnimatedLayerName = styled(Typography)(({ side }: { side: string }) => ({
    position: 'absolute',
    color: 'white',
    top: '50%',
    backgroundColor: 'transparent',
    textShadow: '0px 0px 5px #000000',
    whiteSpace: 'nowrap',
    transform: 'translateY(-50%)',
    opacity: 0, // Start hidden
    animation: 'slideIn 0.2s ease-in-out forwards',
    '@keyframes slideIn': {
        '0%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
    ...(side === 'left' && { right: 60 }),
    ...(side === 'right' && { left: 60 }),
    ...(side === 'top' && { top: -20 }),
}));
